/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';
// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformResolutionObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPLAY_OBJ_RATES,
  screenData: data,
});

//dispatch Quarter From
export const dispatchQtrRange = (data) => ({
  type: actionTypes.GET_FROM_RATES,
  payload: data,
});

// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA_RATES,
  payload: data,
});
//  error msg dispatch function
export const dispatchErrorMsgRates = (data) => ({
  type: actionTypes.GET_ERROR_MSG_RATES,
  payload: data,
});
// error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(dispatchErrorMsgRates([]));
  // }, 5000);
  dispatch(
    dispatchErrorMsgRates([
      {
        field: 'noData',
        message: NO_DATA,
      },
    ])
  );
};
//refresh data
export const refreshSupplementalRates = () => ({
  type: actionTypes.SET_REFRESH_DATA_RATES,
  payload: {},
});
export const refreshSupplementalRatesDisplay = () => ({
  type: actionTypes.SET_REFRESH_DATA_RATES_DISPLAY,
  payload: {},
});
export const dispatchDisplayObjRates = (data) => ({
  type: actionTypes.SET_DISPLAY_OBJ_PRO,
  payload: data,
});
// To dispatch plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};
// rebate programe dispatch function
export const dispatchRebatePrograme = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_RATES,
  payload: data,
});
//on toggle rebate program
export const dispatchRebateProgramName = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_NAME_RATES,
  payload: data,
});

//  get rebate programe function
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {});
};
//Manufacturer Grid
export const getManufacturerList = (values) => (dispatch) => {
  return axios
    .post(
      `${serviceEndPoint.REBATE_PERCENT_OF_SPEND_MANUFACTURER_GRID}`,
      values
    )
    .then((response) => {
      return dispatch({
        type: actionTypes.MANUFACTURER_GRID_RATES,
        manufacturerList: response.data,
      });
    })
    .catch((response) => {
      dispatch([]);
      return response;
    });
};
//dispatch manufacturer
export const dispatchManufacturer = (data) => ({
  type: actionTypes.SET_MANUFACTURER_RATES,
  payload: data,
});
//dispatch supplemental rates
export const dispatchSupplementalRates = (data) => ({
  type: actionTypes.SET_SUPPLEMENTAL_RATES,
  payload: data,
});
export const getSupplementData = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_SUPPLEMENTAL_RATES_DATA, value)
    .then((response) => {
      if (response.data.supplementalRatesReportVO.length == 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(dispatchSupplementalRates(response.data));
      }
    })
    .catch((response) => {
      dispatch(dispatchSupplementalRates([]));
    });
};
